<form [formGroup]="form" (ngSubmit)="submitForm()" class="grid md:grid-cols-2 grid-cols-1 gap-y-1 gap-x-2">
  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>First Name</mat-label>
    <input matInput formControlName="userFirstName" />
    <mat-error *ngIf="form.get('userFirstName')?.hasError('required')">
      First name is required
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>Last Name</mat-label>
    <input matInput formControlName="userLastName" />
    <mat-error *ngIf="form.get('userLastName')?.hasError('required')">
      Last name is required
    </mat-error>
  </mat-form-field>

  <div class="col-span-1 w-full relative">
    <label class="absolute -top-2.5 left-3 bg-white px-1 text-sm text-gray-500 z-10">
      Phone Number
    </label>
    <div
      class="w-full border border-gray-400 rounded-md px-3 py-2 focus-within:border-primary-600 transition-all duration-200">
      <ngx-intl-tel-input
        class="w-full"
        [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="true"
        [enablePlaceholder]="true"
        [searchCountryFlag]="true"
        [searchCountryField]="['name', 'dialCode', 'iso2']"
        [selectFirstCountry]="false"
        [selectedCountryISO]="preferredCountries[0]"
        [separateDialCode]="true"
        formControlName="profilePhone"
        [maxLength]="15"
        [phoneValidation]="true"
      >
      </ngx-intl-tel-input>
    </div>
    <mat-error *ngIf="form.get('profilePhone')?.hasError('required')">
      Phone number is required
    </mat-error>
  </div>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>Passport Number</mat-label>
    <input matInput formControlName="passportNumber" />
    <mat-error *ngIf="form.get('passportNumber')?.hasError('required')">
      Passport number is required
    </mat-error>
    <mat-error *ngIf="form.get('passportNumber')?.hasError('pattern')">
      Invalid passport number
    </mat-error>
  </mat-form-field>

  <mat-form-field class="md:col-span-2 col-span-1 w-full" appearance="outline">
    <mat-label>Email</mat-label>
    <input matInput formControlName="userEmail" />
    <mat-error *ngIf="form.get('userEmail')?.hasError('required')">
      Email is required
    </mat-error>
    <mat-error *ngIf="form.get('userEmail')?.hasError('email')">
      Invalid email
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>Password</mat-label>
    <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="userPassword" />
    <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" tabindex="-1">
      <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
    <mat-error *ngIf="form.get('userPassword').hasError('passwordPolicy')">
      Password must be at least 8 characters long, contain uppercase and lowercase letters, a number, and a special character.
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>Confirm Password</mat-label>
    <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword" />
    <button mat-icon-button matSuffix type="button" (click)="hideConfirmPassword = !hideConfirmPassword" tabindex="-1">
      <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
    <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')">
      Confirm password is required
    </mat-error>
    <mat-error *ngIf="form.get('confirmPassword')?.hasError('passwordMismatch')">
      Passwords do not match
    </mat-error>
  </mat-form-field>

  <div class="md:col-span-2 col-span-1">
    <mat-checkbox formControlName="consent">
      <div class="flex flex-col">
        <p class="font-bold border-b pb-1">Consent</p>
        <span [innerHTML]="privacyPolicyText"></span>
      </div>
    </mat-checkbox>
    <mat-error *ngIf="form.get('consent')?.hasError('required')">
      You must agree to the <a class="underline text-primary-600" href="/privacy-policy" target="_blank">privacy policy</a>.
    </mat-error>
  </div>

  <div class="md:col-span-2 col-span-1 mt-1">
    <button mat-raised-button color="primary" class="w-full py-3" type="submit" [disabled]="form.invalid">
      Save
    </button>
  </div>
</form>
